import { render, staticRenderFns } from "./scanPre.vue?vue&type=template&id=3fab85b6"
import script from "./scanPre.vue?vue&type=script&lang=js"
export * from "./scanPre.vue?vue&type=script&lang=js"
import style0 from "./scanPre.vue?vue&type=style&index=0&id=3fab85b6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports